export const BLOCK_WIDTH = {
  NARROW_WIDTH: 0,
  MEDIUM_WIDTH: 1,
  FULL_WIDTH: 2,
}

export const NARROW_WIDTH_BLOCKS = [
  'EmbeddedYoutubeVideo',
  'Buttons',
  'Media',
  'Categories',
]

export const FULL_WIDTH_BLOCKS = ['RichText', 'Faq']

export function getBlockWidth(blockType) {
  if (FULL_WIDTH_BLOCKS.includes(blockType)) return BLOCK_WIDTH.FULL_WIDTH

  if (NARROW_WIDTH_BLOCKS.includes(blockType)) return BLOCK_WIDTH.NARROW_WIDTH

  return BLOCK_WIDTH.MEDIUM_WIDTH
}
